import { render, staticRenderFns } from "./VTagGroup.vue?vue&type=template&id=aa272e8e&"
import script from "./VTagGroup.vue?vue&type=script&lang=js&"
export * from "./VTagGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports